<div [class.overflow-y-auto]="isModal" lang="es-HN">
  <!-- Header -->
  @if (!isModal) {
  <header
    class="bg-white border-b border-gray-200 sticky top-0 z-10"
    [class.hidden]="shouldHideHeader"
  >
    <div class="px-4 py-3">
      <div class="flex items-center space-x-3">
        <button
          (click)="handleBack()"
          class="p-2 -ml-2 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Volver atrás"
        >
          <lucide-icon
            [name]="arrowLeftIcon"
            [size]="24"
            class="text-gray-700"
          ></lucide-icon>
        </button>
        <div>
          <h1 class="text-xl font-bold text-gray-900 fs-condensed">
            AGREGAR UN VEHÍCULO
          </h1>
        </div>
      </div>
    </div>
  </header>
  }

  <!-- Method Selection Screen -->
  @if (searchMethod === 'select' && !vinSearchComplete) {
  <ng-container *ngTemplateOutlet="methodSelectionScreen"></ng-container>
  }

  <!-- VIN Search Results & Personalization -->
  @if (vinSearchComplete) {
  <ng-container *ngTemplateOutlet="vinSearchResults"></ng-container>
  }

  <!-- Manual Search Flow -->
  @if (searchMethod === 'manual') { @if (loadingRequest) {
  <ng-container *ngTemplateOutlet="loadingRequestComponent"></ng-container>
  } @else {
  <ng-container *ngTemplateOutlet="manualSearchFlow"></ng-container>
  } }

  <!-- VIN Scanner Modal -->
  <ng-container *ngTemplateOutlet="vinScannerModal"></ng-container>
</div>

<!-- TEMPLATES -->

<ng-template #methodSelectionScreen>
  <section class="p-4" aria-labelledby="method-selection-title">
    <h2 id="method-selection-title" class="sr-only">
      Seleccionar método de búsqueda
    </h2>
    <div class="space-y-4">
      <button
        (click)="selectManualMethod()"
        class="w-full bg-white border border-gray-300 p-2 hover:border-blue-500 hover:bg-blue-50 transition-colors text-left"
        aria-describedby="manual-description"
      >
        <div class="flex items-center space-x-6">
          <img
            src="/allas-icons/car-detailed.svg"
            alt="Icono de búsqueda manual"
            width="48"
            height="48"
            loading="lazy"
            class="size-12 object-contain object-center"
          />
          <div class="flex-1">
            <h3 class="font-bold text-gray-900 text-lg fs-condensed">
              Buscar por Marca / Modelo
            </h3>
            <p
              id="manual-description"
              class="text-sm text-gray-600 fs-condensed"
            >
              Seleccionar Año, Marca, Modelo y Motor
            </p>
          </div>
        </div>
      </button>

      <button
        (click)="openVinScanner()"
        class="w-full bg-white border border-gray-300 p-2 hover:border-blue-500 hover:bg-blue-50 transition-colors text-left"
        aria-describedby="vin-description"
      >
        <div class="flex items-center space-x-6">
          <img
            src="/allas-icons/scan.svg"
            alt="Icono de escáner VIN"
            width="48"
            height="48"
            loading="lazy"
            class="size-12 object-contain object-center"
          />
          <div class="flex-1">
            <h3 class="font-bold text-gray-900 text-lg fs-condensed">
              Búsqueda por VIN
            </h3>
            <p id="vin-description" class="text-sm text-gray-600 fs-condensed">
              Escanear o Escribir el Número de Identificación del Vehículo
            </p>
          </div>
        </div>
      </button>

      <button
        disabled
        class="w-full bg-gray-200 border border-gray-300 p-2 transition-colors text-left cursor-not-allowed"
        aria-describedby="plate-description"
      >
        <div class="flex items-center space-x-6">
          <img
            src="/allas-icons/placa.svg"
            alt="Icono de placa"
            width="48"
            height="48"
            loading="lazy"
            class="size-12 object-contain object-center"
          />
          <div class="flex-1">
            <h3 class="font-bold text-gray-900 text-lg fs-condensed">
              Búsqueda por Placa
            </h3>
            <p
              id="plate-description"
              class="text-sm text-gray-600 fs-condensed"
            >
              Buscar por Placa del País (Próximamente)
            </p>
          </div>
        </div>
      </button>
    </div>
  </section>
</ng-template>

<ng-template #vinSearchResults>
  <section class="p-4" aria-labelledby="vin-results-title">
    <div class="mb-6">
      <div class="flex items-center space-x-2 mb-2">
        <lucide-icon
          [name]="checkCircleIcon"
          [size]="24"
          class="text-green-600"
          aria-hidden="true"
        ></lucide-icon>
        <h2 id="vin-results-title" class="text-xl font-bold text-gray-900">
          ¡Vehículo Encontrado!
        </h2>
      </div>
      <p class="text-gray-600">
        Hemos encontrado la información de tu vehículo
      </p>
    </div>

    <div class="space-y-6">
      <div
        class="bg-green-50 border border-green-200 rounded-lg p-4 fs-condensed"
      >
        <h3 class="font-bold text-green-900 mb-3 text-lg">
          Información del vehículo:
        </h3>
        <dl class="space-y-2">
          <div class="flex justify-between items-center">
            <dt class="text-green-700">VIN:</dt>
            <dd class="text-sm text-green-900">{{ vinInput }}</dd>
          </div>
          <div class="flex justify-between items-center">
            <dt class="text-green-700">Año:</dt>
            <dd class="text-green-900">{{ formData.anio }}</dd>
          </div>
          <div class="flex justify-between items-center">
            <dt class="text-green-700">Marca:</dt>
            <dd class="text-green-900">{{ formData.marca }}</dd>
          </div>
          <div class="flex justify-between items-center">
            <dt class="text-green-700">Modelo:</dt>
            <dd class="text-green-900">{{ formData.modelo }}</dd>
          </div>
          <div class="flex justify-between items-center">
            <dt class="text-green-700">Motor:</dt>
            <dd class="text-green-900">{{ formData.motor }}</dd>
          </div>
        </dl>
      </div>

      @if (isUserLoggedIn) {
      <section aria-labelledby="personalization-title">
        <h3 id="personalization-title" class="font-semibold text-gray-900 mb-4">
          Personaliza tu vehículo (Opcional)
        </h3>
        <div class="space-y-4">
          <div>
            <label
              for="vehicle-alias"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Nombre del vehículo
            </label>
            <input
              id="vehicle-alias"
              type="text"
              [(ngModel)]="formData.alias"
              [placeholder]="
                formData.anio + ' ' + formData.marca + ' ' + formData.modelo
              "
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </section>
      } @if (!isUserLoggedIn) {
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <div class="flex items-start space-x-3">
          <div
            class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
          >
            <span class="text-blue-600 text-sm font-bold" aria-hidden="true"
              >i</span
            >
          </div>
          <div>
            <h4 class="font-medium text-blue-900 mb-1">
              ¿Sabías que puedes sincronizar tu garage?
            </h4>
            <p class="text-sm text-blue-700">
              Inicia sesión para sincronizar tus vehículos en todos tus
              dispositivos y acceder a funciones exclusivas como historial de
              compras y recomendaciones personalizadas.
            </p>
          </div>
        </div>
      </div>
      }

      <button
        (click)="handleSubmit()"
        [disabled]="isSubmitting"
        class="w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 font-medium text-lg flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        @if (isSubmitting) {
        <div
          class="animate-spin rounded-full h-5 w-5 border-b-2 border-white"
          aria-hidden="true"
        ></div>
        <span>Agregando...</span>
        } @else {
        <lucide-icon
          [name]="checkCircleIcon"
          [size]="20"
          aria-hidden="true"
        ></lucide-icon>
        <span> AGREGAR Y SELECCIONAR VEHÍCULO </span>
        }
      </button>
    </div>
  </section>
</ng-template>

<ng-template #manualSearchFlow>
  <section class="p-4" aria-labelledby="manual-flow-title">
    <div class="mb-6">
      <div class="flex items-center justify-between mb-4">
        <h2
          id="manual-flow-title"
          class="text-lg font-bold text-gray-900 fs-condensed"
        >
          {{ stepTitle | uppercase }}
        </h2>
        @if (actualStep > 1) {
        <button
          (click)="previousStep()"
          class="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium text-sm"
          aria-label="Volver al paso anterior"
        >
          <lucide-icon
            [name]="arrowLeftIcon"
            [size]="16"
            aria-hidden="true"
          ></lucide-icon>
          Atrás
        </button>
        }
      </div>

      <div class="w-full bg-gray-200 rounded-full h-2 mb-4">
        <div
          class="bg-appPrimary-500 h-2 rounded-full transition-all duration-300"
          [style.width.%]="progressPercentage"
          role="progressbar"
          [attr.aria-valuenow]="actualStep"
          aria-valuemin="1"
          aria-valuemax="7"
          aria-label="Progreso del formulario"
        ></div>
      </div>

      <nav
        class="flex justify-between items-center px-2"
        aria-label="Pasos del formulario"
      >
        @for (stepNumber of getStepNumbers(); track stepNumber) {
        <div class="flex flex-col items-center flex-1">
          <div
            class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-200"
            [class.bg-appPrimary-500]="stepNumber <= actualStep"
            [class.text-white]="stepNumber <= actualStep"
            [class.bg-gray-200]="stepNumber > actualStep"
            [class.text-gray-500]="stepNumber > actualStep"
            [attr.aria-current]="stepNumber === actualStep ? 'step' : null"
          >
            @if (stepNumber < actualStep) {
            <lucide-icon
              [name]="checkIcon"
              [size]="16"
              aria-hidden="true"
            ></lucide-icon>
            } @else {
            {{ stepNumber }}
            }
          </div>
          <span
            class="text-[8px] xl:text-xs mt-1 text-center transition-colors duration-200"
            [class.text-blue-600]="stepNumber <= actualStep"
            [class.text-gray-400]="stepNumber > actualStep"
          >
            {{ getStepLabel(stepNumber) }}
          </span>
        </div>
        }
      </nav>
    </div>

    @if (actualStep === 1) {
    <ng-container *ngTemplateOutlet="step1"></ng-container>
    } @if (actualStep === 2) {
    <ng-container *ngTemplateOutlet="step2"></ng-container>
    } @if (actualStep === 3 && marcaSelected) {
    <ng-container *ngTemplateOutlet="step3"></ng-container>
    } @if (actualStep === 4 && modeloSelected) {
    <ng-container *ngTemplateOutlet="step4"></ng-container>
    } @if (actualStep === 5 && submodeloSelected) {
    <ng-container *ngTemplateOutlet="step5"></ng-container>
    } @if (actualStep === 6) {
    <ng-container *ngTemplateOutlet="step6"></ng-container>
    } @if (actualStep === 7) {
    <ng-container *ngTemplateOutlet="step7"></ng-container>
    }
  </section>
</ng-template>

<ng-template #vinScannerModal>
  @if (isVinScannerOpen) {
  <p-dialog
    appendTo="body"
    [(visible)]="isVinScannerOpen"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [showHeader]="true"
    header="BÚSQUEDA POR VIN"
  >
    <allas-vin-scanner-modal
      (closed)="closeVinScanner()"
      (vinFound)="handleVinFound($event)"
    ></allas-vin-scanner-modal>
  </p-dialog>
  }
</ng-template>

<ng-template #loadingRequestComponent>
  <section
    class="flex flex-col items-center justify-center py-16 px-4"
    aria-labelledby="loading-title"
  >
    <div class="w-16 h-16 rounded-full flex items-center justify-center mb-4">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-appBlack"
        aria-hidden="true"
      ></div>
    </div>
    <h3
      id="loading-title"
      class="text-xl font-bold text-gray-800 mb-2 fs-condensed"
    >
      Cargando...
    </h3>
    <p class="text-gray-600 text-center fs-condensed">Espera un momento</p>
  </section>
</ng-template>

<!-- Step 1: Year Selection -->
<ng-template #step1>
  <section aria-labelledby="year-selection-title">
    <h3 id="year-selection-title" class="sr-only">
      Seleccionar año del vehículo
    </h3>
    <div class="grid grid-cols-2 xl:grid-cols-4 gap-2 bg-gray-100 p-3">
      @for (year of anios; track year) {
      <button
        (click)="handleClickOnYear(year)"
        class="bg-white p-2 drop-shadow-sm border border-gray-200 rounded-lg text-center hover:border-blue-500 hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        [attr.aria-label]="'Seleccionar año ' + year.anio"
      >
        <span class="text-gray-600 fs-condensed">{{ year.anio }}</span>
      </button>
      }
    </div>
  </section>
</ng-template>

<!-- Step 2: Make Selection -->
<ng-template #step2>
  <section aria-labelledby="make-selection-title">
    <h3 id="make-selection-title" class="sr-only">
      Seleccionar marca del vehículo
    </h3>
    <div class="grid grid-cols-2 xl:grid-cols-3 gap-3 bg-gray-100 p-3">
      @for (marca of marcas; track marca) {
      <button
        (click)="handleClickOnMarca(marca)"
        class="bg-white p-2 border border-gray-200 rounded-lg text-left hover:border-blue-500 transition-colors flex justify-center items-center group"
        [attr.aria-label]="'Seleccionar marca ' + marca.descripcion"
      >
        <div class="flex flex-col items-center justify-center mb-2">
          @if (marca.img) {
          <img
            [src]="marca.img"
            onerror="this.src='/placeholder.svg'"
            [alt]="'Logo de ' + marca.descripcion"
            width="40"
            height="40"
            loading="lazy"
            class="w-auto h-10 object-contain rounded grayscale group-hover:grayscale-0"
          />
          <span class="font-bold text-base text-gray-900 fs-condensed">
            {{ marca.descripcion }}
          </span>
          } @else {
          <span class="font-bold text-base text-gray-900 fs-condensed">
            {{ marca.descripcion }}
          </span>
          }
        </div>
      </button>
      }
    </div>
  </section>
</ng-template>

<!-- Step 3: Model Selection -->
<ng-template #step3>
  <section aria-labelledby="model-selection-title">
    <h3 id="model-selection-title" class="sr-only">
      Seleccionar modelo del vehículo
    </h3>
    <div class="flex flex-col gap-2 bg-gray-100 p-3">
      @for (modelo of modelos; track modelo) {
      <button
        (click)="handleClickOnModelo(modelo)"
        class="bg-white text-left pl-10 p-2 drop-shadow-sm border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        [attr.aria-label]="'Seleccionar modelo ' + modelo.descripcion"
      >
        <span class="text-gray-600 fs-condensed">{{ modelo.descripcion }}</span>
      </button>
      }
    </div>
  </section>
</ng-template>

<!-- Step 4: Submodel Selection -->
<ng-template #step4>
  <section aria-labelledby="submodel-selection-title">
    <h3 id="submodel-selection-title" class="sr-only">
      Seleccionar submodelo del vehículo
    </h3>
    <div class="flex flex-col gap-2 bg-gray-100 p-3">
      @for (submodelo of submodelos; track submodelo) {
      <button
        (click)="handleClickOnSubmodelo(submodelo)"
        class="bg-white text-left pl-10 p-2 drop-shadow-sm border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        [attr.aria-label]="'Seleccionar submodelo ' + submodelo.descripcion"
      >
        <span class="text-gray-600 fs-condensed">{{
          submodelo.descripcion
        }}</span>
      </button>
      }
    </div>
  </section>
</ng-template>

<!-- Step 5: Engine Selection -->
<ng-template #step5>
  <section aria-labelledby="engine-selection-title">
    <h3 id="engine-selection-title" class="sr-only">
      Seleccionar motor del vehículo
    </h3>
    <div class="flex flex-col gap-2 bg-gray-100 p-3">
      @for (motor of motores; track motor) {
      <button
        (click)="handleClickOnMotor(motor)"
        class="bg-white text-left pl-10 p-2 drop-shadow-sm border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        [attr.aria-label]="'Seleccionar motor ' + motor.descripcion"
      >
        <span class="text-gray-600 fs-condensed">{{ motor.descripcion }}</span>
      </button>
      }
    </div>
  </section>
</ng-template>

<!-- Step 6: Personalization -->
<ng-template #step6>
  <section aria-labelledby="personalization-step-title">
    <h3 id="personalization-step-title" class="sr-only">
      Personalizar vehículo
    </h3>
    <div class="space-y-6">
      <div>
        <label
          for="vehicle-alias-step6"
          class="block text-sm font-medium text-gray-700 mb-2"
        >
          Nombre del vehículo
        </label>
        <input
          id="vehicle-alias-step6"
          type="text"
          [(ngModel)]="formData.alias"
          [placeholder]="
            formData.anio +
            ' ' +
            (formData.marca || '') +
            ' ' +
            (formData.modelo || '')
          "
          class="w-full px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <button
        (click)="continueToConfirmation()"
        class="w-full bg-appPrimary-500 text-white py-3 px-4 rounded-lg hover:bg-blue-700 font-medium"
      >
        Continuar a Confirmación
      </button>
    </div>
  </section>
</ng-template>

<!-- Step 7: Confirmation -->
<ng-template #step7>
  <section aria-labelledby="confirmation-title">
    <h3 id="confirmation-title" class="sr-only">
      Confirmar información del vehículo
    </h3>
    <div class="flex flex-col space-y-4">
      <!-- Botón arriba para mobile, orden 3 para desktop -->
      <button
        (click)="handleSubmit()"
        [disabled]="isSubmitting"
        class="order-1 md:order-3 w-full bg-allasRed text-white py-2 md:py-3 px-3 md:px-4 rounded-sm hover:bg-opacity-70 font-medium text-sm md:text-lg flex items-center justify-center space-x-1.5 md:space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        @if (isSubmitting) {
        <div
          class="animate-spin rounded-full h-4 md:h-5 w-4 md:w-5 border-b-2 border-white"
          aria-hidden="true"
        ></div>
        <span class="fs-condensed text-sm md:text-base">AGREGANDO...</span>
        } @else {
        <span class="fs-condensed text-sm md:text-base">
          AGREGAR Y SELECCIONAR VEHÍCULO
        </span>
        }
      </button>

      <!-- Información del vehículo -->
      <div
        class="order-2 border border-gray-200 rounded-sm p-4 md:p-6 space-y-4 md:space-y-6"
      >
        <dl class="space-y-3 md:space-y-4">
          <div class="flex justify-between items-center">
            <dt
              class="text-sm md:text-base text-appBlack font-bold fs-condensed"
            >
              Nombre
            </dt>
            <dd
              class="font-medium text-sm md:text-base text-appBlack text-right fs-condensed opacity-80"
            >
              {{
                formData.alias ||
                  formData.anio +
                    " " +
                    (formData.marca || formData.marca) +
                    " " +
                    (formData.modelo || formData.modelo)
              }}
            </dd>
          </div>
          <div class="flex justify-between items-center">
            <dt
              class="text-sm md:text-base text-appBlack font-bold fs-condensed"
            >
              Año
            </dt>
            <dd
              class="font-medium text-sm md:text-base text-appBlack text-right fs-condensed opacity-80"
            >
              {{ formData.anio }}
            </dd>
          </div>
          <div class="flex justify-between items-center">
            <dt
              class="text-sm md:text-base text-appBlack font-bold fs-condensed"
            >
              Marca
            </dt>
            <dd
              class="font-medium text-sm md:text-base text-appBlack text-right fs-condensed opacity-80"
            >
              {{ formData.marca }}
            </dd>
          </div>
          <div class="flex justify-between items-center">
            <dt
              class="text-sm md:text-base text-appBlack font-bold fs-condensed"
            >
              Modelo
            </dt>
            <dd
              class="font-medium text-sm md:text-base text-appBlack text-right fs-condensed opacity-80"
            >
              {{ formData.modelo }}
            </dd>
          </div>
          <div class="flex justify-between items-center">
            <dt
              class="text-sm md:text-base text-appBlack font-bold fs-condensed"
            >
              Submodelo
            </dt>
            <dd
              class="font-medium text-sm md:text-base text-appBlack text-right fs-condensed opacity-80"
            >
              {{ submodeloSelected?.descripcion || formData.idSubmodeloMotor }}
            </dd>
          </div>
          <div class="flex justify-between items-center">
            <dt
              class="text-sm md:text-base text-appBlack font-bold fs-condensed"
            >
              Motor
            </dt>
            <dd
              class="font-medium text-sm md:text-base text-appBlack text-right fs-condensed opacity-80"
            >
              {{ formData.motor || "No especificado" }}
            </dd>
          </div>
        </dl>
        <div
          class="text-appPrimary-500 font-semibold pt-2 text-sm md:text-base fs-condensed"
        >
          SERÁ TU VEHÍCULO SELECCIONADO
        </div>
      </div>

      <!-- Mensaje para usuarios no logueados -->
      @if (!isUserLoggedIn) {
      <div
        class="order-2 md:order-2 border border-gray-200 rounded-sm p-3 md:p-4"
      >
        <h4
          class="text-base md:text-lg font-medium text-gray-600 mb-1 fs-condensed"
        >
          ¿Sabías que puedes sincronizar tu garage?
        </h4>
        <p class="text-sm md:text-base text-gray-500 fs-condensed">
          Inicia sesión para sincronizar tus vehículos en todos tus dispositivos
          y acceder a funciones exclusivas como historial de compras y
          recomendaciones personalizadas.
        </p>
      </div>
      }
    </div>
  </section>
</ng-template>
